import { FC } from 'react'
import { signIn } from 'next-auth/react'
import { useTranslation } from '@hooks/useTranslation'
import { useWeb3Modal, useWeb3ModalAccount, useWeb3ModalProvider } from '@web3modal/ethers/react'
import { useRouter } from 'next/router'
import { Button } from '@components/UIKit/Button/Button'
import { LinksEnum } from '@specs/navigation'
import { useSignature } from '@services/auth/hooks/useSignature'

interface Props {
    className?: string
    isDisabled: boolean
}

export const WalletButton: FC<Props> = ({ isDisabled }) => {
    const { translate: tr } = useTranslation()
    const router = useRouter()
    const { walletProvider } = useWeb3ModalProvider()
    const { isConnected } = useWeb3ModalAccount()
    const { open } = useWeb3Modal()
    const { signMessage } = useSignature()

    const LoginWithSignWallet = async () => {
        if (typeof walletProvider === 'undefined') return
        try {
            const result = await signMessage()
            if (typeof result === 'undefined') {
                await router.push(LinksEnum.SIGN_IN_ERROR)
                return
            }
            const { signature, message } = result
            await signIn('wallet', { redirect: true, signature, message })

        } catch (error) {
            console.warn('error', error)
            await router.push(LinksEnum.SIGN_IN_ERROR)
        }
    }

    return (
        <Button
            id='wallet_button'
            size={'large'}
            color={'White'}
            onClick={async () => {
                if (!isConnected) return await open()
                await LoginWithSignWallet()
            }}
            icons={{
                left: {
                    name: 'wallet',
                },
            }}
            disabled={isDisabled}
        >
            {tr({ id: isConnected ? 'auth.page.sing.in.wallet' : 'auth.page.connect.wallet' })}
        </Button>
    )
}
